import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { Loader2 } from 'lucide-react'
import { motion } from 'framer-motion'

// Staggered animation for buttons
const containerAnimation = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

const itemAnimation = {
  hidden: { opacity: 0, y: 10 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
      ease: 'easeOut',
    },
  },
}

const SocialButtons = ({ handleSocialAuth, isLoading, isSignUp }) => {
  const { t } = useTranslation('common')

  return (
    <motion.div className="space-y-3" variants={containerAnimation} initial="hidden" animate="show">
      {/* Discord Button */}
      <motion.button
        variants={itemAnimation}
        onClick={() => handleSocialAuth('discord')}
        disabled={isLoading.discord}
        className="w-full h-14 flex items-center bg-white border border-gray-200 rounded-md transition-all duration-200 hover:shadow-md hover:border-gray-300 overflow-hidden group disabled:opacity-70 disabled:cursor-not-allowed"
      >
        <div className="h-full aspect-square bg-white flex items-center justify-center border-r border-gray-200 group-hover:bg-gray-50 transition-colors duration-200">
          {isLoading.discord ? (
            <Loader2 className="h-6 w-6 animate-spin" />
          ) : (
            <Image
              src="/assets/auth-modal/discord-logo-new.png"
              placeholder="blur"
              blurDataURL={'/assets/auth-modal/discord-logo-new.png'}
              alt="Discord"
              width={28}
              height={28}
              priority
            />
          )}
        </div>
        <div className="flex-1 h-full bg-white  flex items-center justify-center group-hover:bg-gray-50 transition-colors duration-200">
          <span className="text-black text-sm font-medium">
            {isSignUp ? t('auth.sign_up_with_discord') : t('auth.continue_with_discord')}
          </span>
        </div>
      </motion.button>

      {/* Google Button */}
      <motion.button
        variants={itemAnimation}
        onClick={() => handleSocialAuth('google')}
        disabled={isLoading.google}
        className="w-full h-14 flex items-center rounded-md transition-all duration-200 hover:shadow-md overflow-hidden border  disabled:opacity-70 disabled:cursor-not-allowed"
      >
        <div className="h-full aspect-square bg-white flex items-center justify-center">
          {isLoading.google ? (
            <Loader2 className="h-6 w-6 animate-spin" />
          ) : (
            <Image
              src="/assets/auth-modal/google-g-logo.png"
              placeholder="blur"
              blurDataURL={'/assets/auth-modal/google-g-logo.png'}
              alt="Google"
              width={24}
              height={24}
              priority
            />
          )}
        </div>
        <div className="flex-1 h-full bg-black flex items-center justify-center">
          <span className="text-white text-sm font-medium ">
            {isSignUp ? t('auth.sign_up_with_google') : t('auth.continue_with_google')}
          </span>
        </div>
      </motion.button>
    </motion.div>
  )
}

export default SocialButtons
